import { createContext, useContext } from "react";

const MyTasksColumnsContext = createContext({});

export const MyTasksColumnsContextProvider = MyTasksColumnsContext.Provider;
export const MyTasksColumnsContextConsumer = MyTasksColumnsContext.Consumer;

export const useMyTasksColumnsContext = () => useContext(MyTasksColumnsContext);

export default MyTasksColumnsContext;
